export const allprojectListActions = {
    SET_ALLPROJECTS: 'SET_ALLPROJECTS'
};

const allProjectsReducer = (state, action) => {
    switch (action.type) {
        case allprojectListActions.SET_ALLPROJECTS:
            return {
                ...state,
                allprojectList: action.allprojectList,
            };
        default:
            return {
                state
            };
    }
};

export default allProjectsReducer;